import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Idiomas } from '../../core/model/idiomas';
import { SpecialFormValidators } from '../../core/model/specialFormValidators';
import { ParametrosCliente, ParametrosUpdate, ParametrosUsuario, Userprofile, UsuarioUpdate } from '../../core/model/users';
import { AuthenticationService } from '../../core/services/authentication.service';
import { PopulateService } from '../../core/services/populate.service';
import { UsersService } from '../../core/services/users.service';

@Component({
  selector: "app-perfil",
  templateUrl: "./perfil.component.html",
  styleUrls: ["./perfil.component.css"],
  providers: [PopulateService]
})
export class PerfilComponent implements OnInit, OnDestroy {
  Boxtype = "box-primary";
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  isDocoutUser: boolean;

  // Propiedades del componente
  infoUser = new Userprofile();
  updateUser = new UsuarioUpdate();
  updateParam: ParametrosUpdate[];
  statusCode: number;
  profileProcessing = false;
  requestProcessing = true;
  passwordProcessing = false;
  addressProcessing = false;
  userIdToUpdate = null;
  processValidation = false;
  validPass = true;
  validPassLength = true;
  formatError = false;
  profileToShow: string;
  passwordToShow: string;
  paramsmsToShow: string;
  idiomasList: Idiomas[];
  repeatedPass: string;
  userForm: FormGroup;
  parametrousuario: ParametrosUsuario[];

  paramForm: FormGroup;
  objectProps = [];
  allParamsUser: ParametrosCliente[];
  noDataParam = false;
  isSsoAuthentication = false;

  private subscription: Subscription;
  private subscription_change: Subscription;
  private subscription_update: Subscription;
  private subscription_get: Subscription;
  private subscription_lang: Subscription;

  constructor(
    private usersservice: UsersService,
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private translateService: TranslateService,
    private populateservice: PopulateService,
    private fb: FormBuilder
  ) {
    this.createUserForm();
  }

  ngOnInit(): void {
    this.SetEnviroment();
    this.getAllLanguagesAvailables();
    this.loadUserProfile();
  }

  SetEnviroment() {
    this.authService.isDocOutUser().then((isDocUser: boolean) => {
      this.isDocoutUser = isDocUser;
    });

    this.Padre = this.authService.getClienteName();
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
    if (this.subscription_change && !this.subscription_change.closed) {
      this.subscription_change.unsubscribe();
    }
    if (this.subscription_update && !this.subscription_update.closed) {
      this.subscription_update.unsubscribe();
    }
    if (this.subscription_get && !this.subscription_get.closed) {
      this.subscription_get.unsubscribe();
    }
    if (this.subscription_lang && !this.subscription_lang.closed) {
      this.subscription_lang.unsubscribe();
    }
    this.translateService = null;
    this.usersservice = null;
    this.authService = null;
    this.populateservice = null;
  }

  useLanguage(language: string) {
    this.subscription = this.translateService.use(language).subscribe(
      res => {},
      error => {
        this.toastr.warning(
          "No se ha podido cambiar el idioma. Se usara el idioma por defecto del navegador",
          "Aviso"
        );
      }
    );
    localStorage.setItem("idioma", language);
  }

  getAllLanguagesAvailables() {
    this.subscription_lang = this.populateservice
      .getLanguagesAvailables()
      .subscribe(
        lang => {
          this.idiomasList = new Array();
          this.idiomasList = lang;
        },
        errorCode => {
          // this.statusCode = errorCode;
          this.toastr.warning(
            "Se usara el idioma por defecto del navegador",
            "Error al cargar"
          );
        }
      );
  }

  getIdByLanguage(prefijo: string): number {
    const lang = this.idiomasList.filter(item => item.PREFIJO === prefijo);
    return lang[0].Id;
  }

    createUserForm() {
        this.isSsoAuthentication = this.authService.isSsoAuthentication();
    this.userForm = this.fb.group({
      user: [
        { value: this.infoUser.USER, disabled: true },
        Validators.required
      ],
      email: [
        { value: this.infoUser.EMAIL, disabled: this.isSsoAuthentication },
        [Validators.required, Validators.email, Validators.maxLength(50)]
      ],
      nombre: [
        {
          value: this.infoUser.NOMBRE,
          disabled: this.isSsoAuthentication
        },
        [Validators.required, Validators.maxLength(25)]
      ],
      apellidos: [
        {
          value: this.infoUser.APELLIDOS,
          disabled: this.isSsoAuthentication
        },
        [Validators.required, Validators.maxLength(25)]
      ],
      idiomas: [
        {
          value: this.infoUser.ID_IDIOMA,
          disabled: this.isSsoAuthentication
        }
      ],
      currentPass: [{ value: "", disabled: this.isSsoAuthentication }],
      newpass: [
        { value: "", disabled: this.isSsoAuthentication },
        Validators.maxLength(16)
      ],
      pass: [
        { value: "", disabled: this.isSsoAuthentication },
        Validators.maxLength(16)
      ],
      notificaciones: [
        {
          value: this.infoUser.RECIBIR_NOTIFICACIONES,
          disabled: this.isSsoAuthentication
        }
      ],
      grupo: [
        { value: this.infoUser.groupName, disabled: true },
        Validators.required
      ],
      telefono: [
        { value: this.infoUser.TELEFONO, disabled: this.isSsoAuthentication },
        [SpecialFormValidators.validateMovilNumber]
      ],
      telefonoOficina: [
        {
          value: this.infoUser.TELEFONO_OFICINA,
          disabled: this.isSsoAuthentication
        },
        [SpecialFormValidators.validateMovilNumber]
      ]
    });
  }

  get user() {
    return this.userForm.get("user");
  }
  get email() {
    return this.userForm.get("email");
  }
  get nombre() {
    return this.userForm.get("nombre");
  }
  get apellidos() {
    return this.userForm.get("apellidos");
  }
  get idiomas() {
    return this.userForm.get("idiomas");
  }
  get newpass() {
    return this.userForm.get("newpass");
  }
  get pass() {
    return this.userForm.get("pass");
  }
  get notificaciones() {
    return this.userForm.get("notificaciones");
  }
  get telefono() {
    return this.userForm.get("telefono");
  }
  get telefonoOficina() {
    return this.userForm.get("telefonoOficina");
  }

  onUserFormSubmit() {
    this.processValidation = true;
    if (this.userForm.invalid) {
      return; // Validation failed, exit from method.
    }
    // Form is valid, now perform create or update
    this.preProcessProfile("Modificando el perfil del usuario");
    const idiomasFiltrados = this.idiomasList.filter((idioma: Idiomas) => {
      return idioma.Id === +this.infoUser.ID_IDIOMA;
    });
    this.infoUser.IDIOMA.PREFIJO = idiomasFiltrados[0].PREFIJO;
    this.setUpdateUserValue();

    this.subscription_update = this.usersservice
      .updateUser(this.updateUser)
      .subscribe(
        response => {
          const hasError = this.authService.checkGeneralError(response.body);
          if (!hasError) {
            this.subscription = this.translateService
              .get(["mensajes"])
              .subscribe(values => {
                this.toastr.success(
                  values["mensajes"]["userupdate"],
                  values["mensajes"]["userupdatetitle"]
                );
              });

            this.useLanguage(this.infoUser.IDIOMA.PREFIJO);
            this.statusCode = response.status;
            this.authService.closePriorNotice();
          }

          this.loadUserProfile();
          this.setUpdateUserValue(true);
        },
        errorCode => {
          this.statusCode = errorCode;
          // this.toastr.warning('No se ha podido modificar el usuario', 'Error al modificar');
          this.subscription = this.translateService
            .get(["mensajes"])
            .subscribe(values => {
              this.toastr.warning(
                values["mensajes"]["usernoupdate"],
                values["mensajes"]["usernoupdatetitle"]
              );
            });
          this.loadUserProfile();
        }
      );
  }

  setUpdateUserValue(resetPassword?: boolean) {
    const user = this.userForm.value;

    this.updateUser.USER = this.infoUser.USER;
    this.updateUser.ID_IDIOMA = this.infoUser.ID_IDIOMA;
    this.updateUser.NOMBRE = user.nombre;
    this.updateUser.APELLIDOS = user.apellidos;
    this.updateUser.ID_GROUP = this.infoUser.ID_GROUP;
    this.updateUser.Id = this.userIdToUpdate;
    this.updateUser.ACTIVO = this.infoUser.ACTIVO;
    this.updateUser.EMAIL = user.email;
    this.updateUser.RECIBIR_NOTIFICACIONES = user.notificaciones === "SI";
    this.updateUser.TELEFONO = this.infoUser.TELEFONO;
    this.updateUser.TELEFONO_OFICINA = this.infoUser.TELEFONO_OFICINA;
    if (this.updateUser.PASS === undefined || resetPassword) {
      this.updateUser.PASS = "";
      this.repeatedPass = "";
    }
  }

  loadUserProfile() {
    this.preProcessProfile("Cargando perfil del usuario");
    this.subscription_get = this.usersservice.getUserById(undefined).subscribe(
      usuario => {
        this.parametrousuario = usuario.PARAMETROS || [];
        this.userIdToUpdate = usuario.Id;
        this.infoUser = usuario;

        this.createUserForm();

        if (this.infoUser.IDIOMA) {
          this.infoUser.IDIOMA.PREFIJO = usuario.IDIOMA.PREFIJO;
          this.userForm.controls["idiomas"].setValue(this.infoUser.ID_IDIOMA);
        } else {
          this.userForm.controls["idiomas"].setValue("es");
        }

        this.processValidation = true;
        this.profileProcessing = false;

        this.getParametros();
      },
      errorCode => {
        this.statusCode = 500;
        this.subscription = this.translateService
          .get(["mensajes"])
          .subscribe(values => {
            this.toastr.warning(
              values["mensajes"]["nodata"],
              values["mensajes"]["nodatatitle"]
            );
          });
      }
    );
  }

  checkNewPassword() {
    if (
      !this.hasData(this.updateUser.PASS) &&
      !this.hasData(this.repeatedPass)
    ) {
      this.validPass = true;
      return;
    }
    if (this.updateUser.PASS !== this.repeatedPass) {
      this.validPass = false;
      return;
    }
    if (this.repeatedPass != "") {
      this.passwordValidation();
      this.validPass = true;
    }
  }
  private hasData(data: string) {
    return !(!data || data == "");
  }

  checkPasswordLength() {
    if (
      this.updateUser.PASS &&
      (this.updateUser.PASS.length < 8 || this.updateUser.PASS.length > 16)
    ) {
      this.validPassLength = false;
      return;
    }
    this.validPassLength = true;
    this.validPass = false;
    if (this.repeatedPass !== undefined) {
      this.checkNewPassword();
      return;
    }
  }

  passwordValidation() {
    let mayusculas = false;
    let minusculas = false;
    let numeros = false;
    for (let x = 0; x < this.updateUser.PASS.length; x++) {
      const char = this.updateUser.PASS.charAt(x);
      if (char >= "a" && char <= "z") {
        minusculas = true;
      }
      if (char >= "A" && char <= "Z") {
        mayusculas = true;
      }
      if (char >= "0" && char <= "9") {
        numeros = true;
      }
    }
    if (!minusculas || !mayusculas || !numeros) {
      this.formatError = true;
    } else {
      this.formatError = false;
    }
    return;
  }

  preProcessProfile(mensaje: string) {
    this.profileToShow = mensaje;
    this.statusCode = null;
    this.profileProcessing = true;
  }

  preProcessParameters(mensaje: string) {
    this.paramsmsToShow = mensaje;
    this.statusCode = null;
    this.requestProcessing = true;
  }

  getParametros() {
    this.preProcessParameters("Recuperando parámetros del usuario");
    this.subscription_get = this.usersservice
      .getParametrosUsuario(undefined)
      .subscribe(
        parametros => {
          this.noDataParam = false;
          this.allParamsUser = parametros;
          if (this.allParamsUser.length <= 0) {
            this.noDataParam = true;
          } else {
            this.createParamForm();
          }
          this.requestProcessing = false;
        },
        errorCode => {
          this.statusCode = 500;
          this.subscription = this.translateService
            .get(["mensajes"])
            .subscribe(values => {
              this.toastr.warning(
                values["mensajes"]["nodata"],
                values["mensajes"]["nodatatitle"]
              );
            });
        }
      );
  }

  createParamForm() {
    this.objectProps = Object.keys(this.allParamsUser).map(prop => {
      return Object.assign({}, { key: prop }, this.allParamsUser[prop]);
    });

    // setup the form
    const formGroup = {};
    let elemento;
    let valor = "";

    for (const prop of Object.keys(this.allParamsUser)) {
      // formGroup[prop] = new FormControl(this.allParamsUser[prop].value || '', this.mapValidators(this.allParamsUser[prop].validation));
      if (this.parametrousuario) {
        elemento = this.parametrousuario.find(
          obj =>
            obj.ID_PARAMETRO_CLIENTE_USUARIO ==
            this.allParamsUser[prop].ParametroUsuario.Id
        );
      }
      if (elemento) {
        valor = elemento.VALOR;
      } else {
        valor = "";
      }
      formGroup[prop] = new FormControl(valor || "");
    }
    this.paramForm = new FormGroup(formGroup);
  }

  onParamSubmit() {
    if (this.paramForm.invalid) {
      return; // Validation failed, exit from method.
    }
    // Form is valid, now perform create or update
    this.preProcessParameters("Modificando los parámetros del usuario");
    this.updateParam = [];
    let abstractControl;
    const elementos = this.allParamsUser;
    Object.keys(this.paramForm.controls).forEach(key => {
      abstractControl = this.paramForm.controls[key];
      this.updateParam.push({
        ID_USUARIO: 0,
        ID_USU_PARAM_CLI: elementos[key].ID_USU_PARAM,
        VALOR: abstractControl.value
      });
    });

    this.subscription_update = this.usersservice
      .updateParams(this.updateParam)
      .subscribe(
        successCode => {
          this.subscription = this.translateService
            .get(["perfil"])
            .subscribe(values => {
              this.toastr.success(
                values["perfil"]["paramupdate"],
                values["perfil"]["titleparam"]
              );
            });
          this.statusCode = successCode;
          this.requestProcessing = false;
          this.noDataParam = false;
        },
        errorCode => {
          this.statusCode = errorCode;
          // this.toastr.warning('No se ha podido modificar el usuario', 'Error al modificar');
          this.subscription = this.translateService
            .get(["perfil"])
            .subscribe(values => {
              this.toastr.warning(
                values["perfil"]["paramnoupdate"],
                values["perfil"]["titleparam"]
              );
            });
        }
      );
  }

  isCurrentPasswordMandatory() {
    return (
      !this.hasData(this.updateUser.CURRENT_PASS) &&
      this.hasData(this.updateUser.PASS) &&
      this.userForm.get("newpass").valid
    );
  }

  isButtonModifyDisabled(): boolean {
    return (
      !this.userForm.valid ||
      !this.validPass ||
      !this.validPassLength ||
      this.formatError ||
      this.isCurrentPasswordMandatory()
    );
  }
}

